import React from "react";
import { Link } from "react-router-dom";

// Image imports
import footerBg from "../../images/bg/footer-bg.png";
import emailIcon from "../../images/icon/email-icon.svg";
import locationIcon from "../../images/icon/location-icon.svg";
import callIcon from "../../images/icon/call-icon.svg";

const Footer: React.FC = () => {
  const arrowIcon = (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="5.06641"
        y="19.2783"
        width="20.5712"
        height="2.61221"
        transform="rotate(-40.2798 5.06641 19.2783)"
        fill="white"
      />
      <rect
        x="7.97144"
        y="6.54443"
        width="2.61221"
        height="2.61221"
        transform="rotate(-40.2798 7.97144 6.54443)"
        fill="white"
      />
      <rect
        x="11.6528"
        y="6.84814"
        width="2.61221"
        height="2.61221"
        transform="rotate(-40.2798 11.6528 6.84814)"
        fill="white"
      />
      <rect
        x="15.3345"
        y="7.15186"
        width="2.61221"
        height="2.61221"
        transform="rotate(-40.2798 15.3345 7.15186)"
        fill="white"
      />
      <rect
        x="18.7124"
        y="11.1372"
        width="2.61221"
        height="2.61221"
        transform="rotate(-40.2798 18.7124 11.1372)"
        fill="white"
      />
      <rect
        x="18.4089"
        y="14.8198"
        width="2.61221"
        height="2.61221"
        transform="rotate(-40.2798 18.4089 14.8198)"
        fill="white"
      />
      <rect
        x="18.1045"
        y="18.501"
        width="2.61221"
        height="2.61221"
        transform="rotate(-40.2798 18.1045 18.501)"
        fill="white"
      />
    </svg>
  );

  // ONLY YOUR ORIGINAL 4 SOCIALS
  const socials = [
    {
      icon: <i className="fa-brands fa-facebook"></i>,
      name: "Facebook",
      url: "https://www.facebook.com/people/Aquar-Labs/61562095551715/",
    },
    {
      icon: (
        <svg
          width="19"
          height="19"
          viewBox="0 0 19 19"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.46973 0C14.6996 0 18.9395 4.25357 18.9395 9.5C18.9394 14.7464 14.6996 19 9.46973 19C4.24002 18.9998 8.74258e-05 14.7463 0 9.5C0 4.25366 4.23997 0.000150177 9.46973 0ZM8.27441 10.1201L4.02344 15.0771H4.98438L8.70117 10.7422L11.6709 15.0771H14.9131L10.5039 8.64062L14.5586 3.91309H13.5977L10.0771 8.01758L7.26562 3.91309H4.02344L8.27441 10.1201ZM13.5977 14.3848H12.1221L5.33008 4.63867H6.80566L13.5977 14.3848Z"
            fill="#FFF"
          />
        </svg>
      ),
      name: "Twitter",
      url: "https://x.com/aquarlabs",
    },
    {
      icon: <i className="fa-brands fa-linkedin"></i>,
      name: "LinkedIn",
      url: "https://www.linkedin.com/company/aquarlabs",
    },
    {
      icon: <i className="fa-brands fa-square-youtube"></i>,
      name: "YouTube",
      url: "https://www.youtube.com/@aquarlabs",
    },
  ];

  return (
    <footer
      className="footer footer-style-one pt-145 bg_img"
      style={{ backgroundImage: `url(${footerBg})` }}
    >
      <div className="xb-footer-wrap">
        {/* Footer Heading */}
        <div className="ai-footer-heading" data-wow-delay="0ms" data-wow-duration="600ms">

          <h1 className="title">AquarLabs</h1>
          {/* <a className="mail" href="mailto:info@aquarlabs.com">
            <img src={emailIcon} alt="email" /> info@aquarlabs.com
          </a> */}
        </div>

        {/* Footer Navigation */}
        <div className="xb-footer-nav">
          <div className="xb-footer-nav-item">
            <span className="sub-title">What we do?</span>
            <h2 className="title">
              <Link to="/services">Services</Link>
            </h2>
          </div>
          <div className="xb-footer-nav-item">
            <span className="sub-title">Who we are?</span>
            <h2 className="title">
              <Link to="/about-us">About us</Link>
            </h2>
          </div>
          <div className="xb-footer-nav-item">
            <span className="sub-title">How we deliver</span>
            <h2 className="title">
              <Link to="/contact-us">Contact us</Link>
            </h2>
          </div>
          {/* <div className="xb-footer-nav-item">
            <span className="sub-title">What we're good at?</span>
            <h2 className="title">
              <Link to="/project">Our project</Link>
            </h2>
          </div> */}
          <div className="xb-footer-nav-item">
            <span className="sub-title">News?</span>
            <h2 className="title">
              <Link to="https://blog.aquarlabs.com">Blog</Link>
            </h2>
          </div>
        </div>

        {/* Social Media Section */}
        <div className="xb-social-media-wrap">
          {socials.map((social, idx) => (
            <div className="xb-social-media-item ul_li_between" key={idx}>
              <div className="xb-item--holder ul_li">
                <div className="xb-item--icon">{social.icon}</div>
                <span className="xb-item--name">{social.name}</span>
              </div>

              <span className="xb-item--arrow">{arrowIcon}</span>

              <a
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={social.name}
                className="xb-overlay"
              ></a>
            </div>
          ))}
        </div>

        {/* Footer Bottom */}
        <div className="xb-footer-bottom">
          <div className="contact-item">
            <img src={locationIcon} alt="location" />
            <span className="contact-method">Visakhapatnam, India</span>
          </div>

          <div className="contact-item copyright-item" style={{ flexDirection: "column", alignItems: "center", gap: "10px" }}>
            <p>
              Copyright © 2026 <Link to="/">Aquar Labs</Link>
            </p>
            <div style={{ display: "flex", gap: "20px", flexWrap: "wrap", justifyContent: "center" }}>
              <Link to="/privacy-policy" style={{ fontSize: "14px", color: "rgba(255,255,255,0.7)" }}>Privacy Policy</Link>
              <span style={{ color: "rgba(255,255,255,0.3)" }}>|</span>
              <Link to="/terms-of-service" style={{ fontSize: "14px", color: "rgba(255,255,255,0.7)" }}>Terms of Service</Link>
              <span style={{ color: "rgba(255,255,255,0.3)" }}>|</span>
              <Link to="/refund-policy" style={{ fontSize: "14px", color: "rgba(255,255,255,0.7)" }}>Refund Policy</Link>
            </div>
          </div>

          <div className="contact-item " style={{ flexWrap: "wrap" }}>
            {/* mail */}
            <div style={{ display: "flex", alignItems: "center", gap: "8px", width: "100%", marginTop: '10px' }}>
              <a href="mailto:info@aquarlabs.com" className="contact-icon">
                <img src={emailIcon} alt="email" />
              </a>
              <a className="contact-method" href="mailto:info@aquarlabs.com">
                info@aquarlabs.com
              </a>
            </div>
            {/* call */}
            <div style={{ display: "flex", alignItems: "center", gap: "8px", width: "100%" }}>
              <a href="tel:+918367036704" className="contact-icon">
                <img src={callIcon} alt="call" />
              </a>
              <a className="contact-method" href="tel:+918367036704">
                +(91) 8 3670 3670 4
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
